export const FIELDS_BUSINESS = [
  { value: "all", label: "all" },
  { value: "agriculture", label: "agriculture" },
  { value: "air", label: "air" },
  { value: "food", label: "food" },
  { value: "finance", label: "finance" },
  { value: "digital technology", label: "digital technology" },
  { value: "renewable energy", label: "renewable energy" },
  { value: "eco-building", label: "eco-building" },
  { value: "ecological engineering", label: "ecological engineering" },
  { value: "environmental law", label: "environmental law" },
  { value: "ecotourism", label: "ecotourism" },
  { value: "education", label: "education" },
  { value: "equipment", label: "equipment" },
  { value: "cosmetics", label: "cosmetics" },
  { value: "consulting", label: "consulting" },
  { value: "laboratory", label: "laboratory" },
  { value: "planting trees", label: "planting trees" },
  { value: "packaging", label: "packaging" },
  { value: "renovation", label: "renovation" },
  { value: "fashion", label: "fashion" },
  { value: "household products", label: "household products" },
  { value: "science", label: "science" },
  { value: "water", label: "water" },
  { value: "waste", label: "waste" },
  { value: "transportation", label: "transportation" },
  { value: "logistics", label: "logistics" },
  { value: "children", label: "children" },
  { value: "climate", label: "climate" }
];

export const CATEGORY_BUSINESS = [
  { value: "sale", label: "sale" },
  { value: "production", label: "production" },
  { value: "equipment", label: "equipment" },
  { value: "services", label: "services" }
];

export const FIELDS_TYPES = [
  { value: "business", label: "business" },
  { value: "NGO", label: "NGO" },
  { value: "government", label: "government" },
  { value: "media", label: "media" },
  { value: "hotSpot", label: "Hot Spot" },
  { value: "greenSpot", label: "Green Spot" }
]